import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { makeStyles } from '@material-ui/core/styles';
import ApplicationDetail from './applicationDetail';
import { DownloadIcon, PrintIcon } from '@egovernments/digit-ui-react-components';
import ReactToPrint from 'react-to-print';
import { FaFileExcel } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { ConvertEpochToDate } from '@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date';
import { convertEpochToDate } from '@egovernments/digit-ui-module-pt/src/utils';


const useStyles = makeStyles((theme) => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`,
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px',
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px',
    },
  },
}));

function RegistrationReport() {
  const classes = useStyles()
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = React.useState('1');
  const componentPDF = React.useRef();
  const [apiData, setApiData] = useState(null);
  const { t } = useTranslation();

  const handleChange = (newValue) => {
    setValue(newValue);
  };
   const handleExcelDownload = () => {
      const charData = apiData?.Licenses?.map((st) => ({
        registrationType: st?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType?.split(".")?.[0],
        applicationnumber: st?.applicationNumber,
        licenseNumber: st?.tradeLicenseDetail?.owners?.[0]?.architectureNo,
        applicantName: st?.tradeLicenseDetail?.owners?.[0]?.name,
        mobileNumber: st?.tradeLicenseDetail?.owners?.[0]?.mobileNumber,
        emailId: st?.tradeLicenseDetail?.owners?.[0]?.emailId,
        //issue in below column
        authorityName: st?.tradeLicenseDetail?.additionalDetail?.authorityName,
        appliedOn: convertEpochToDate(st?.tradeLicenseDetail?.additionalDetail?.applicationDate),
        validupto: st?.tradeLicenseDetail?.additionalDetail?.validupto,
        paymentDate: convertEpochToDate(st?.txnCreatedTime) || "N/A", // nf
        estimateAmount:  st?.tradeLicenseDetail?.additionalDetail?.calculation?.taxHeadEstimates?.[0]?.estimateAmount || 0,
        status: t(st?.status),
      })); 
      return Digit.Download.Excel(charData, "registration-report");
    };
  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginLeft: '20px' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example" defaultIndex={selectedTabIndex}>
            <Tab label="Registrations Report" value="1" className={classes.customTab} />
            <ReactToPrint
              trigger={() => <button style={{ marginLeft: '45rem' }} id="invoice-print"><PrintIcon /></button>}
              content={() => componentPDF.current}
            />
            <button className="mrlg cursorPointer" onClick={handleExcelDownload} style={{marginLeft: '3rem'}}>
              <FaFileExcel style={{ fontSize: '22px' }}/>
            </button>

          </TabList>
        </Box>
        <div ref={componentPDF}>
          <TabPanel value="1">
            <ApplicationDetail setApiData={setApiData} apiData={apiData} />
          </TabPanel>

        </div>

      </TabContext>
    </Box>
  );
}

export default RegistrationReport